import AiMazeGeneration from './AiMazeGneration'

export default AiMazeGeneration
